import { useEffect, useState } from "react";
import api from "@/lib/api";
import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { num } from "@/lib/format";
import { Badge } from "@/components/ui/badge";

const STATUS = {
  draft: "bg-slate-100 text-slate-700 border",
  proses: "bg-blue-100 text-blue-800 border-blue-200 border",
  selesai: "bg-green-100 text-green-800 border-green-200 border",
  dibatalkan: "bg-red-100 text-red-800 border-red-200 border",
};

export default function Orders() {
  const { user } = useAuth();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  if (!products) return <div className="text-slate-400 py-20 text-center">Memuat...</div>;
  const pmap = Object.fromEntries(products.map((p) => [p.id, p.name]));

  return (
    <CrudPage
      title="Pesanan Pelanggan"
      subtitle="Kelola pesanan dan hubungkan dengan batch produksi."
      endpoint="/orders"
      canWrite={canWrite(user?.role, ["akuntansi", "admin_produksi"])}
      searchKeys={["no_pesanan", "pelanggan"]}
      columns={[
        { key: "no_pesanan", label: "No. Pesanan" },
        { key: "pelanggan", label: "Pelanggan" },
        { key: "product_id", label: "Produk", render: (r) => pmap[r.product_id] || "-" },
        { key: "volume", label: "Volume", align: "right", render: (r) => num(r.volume, 1) },
        { key: "tanggal", label: "Tanggal" },
        { key: "deadline", label: "Deadline" },
        { key: "status", label: "Status", render: (r) => <Badge className={`${STATUS[r.status]} capitalize`}>{r.status}</Badge> },
      ]}
      fields={[
        { key: "no_pesanan", label: "No. Pesanan (kosongkan untuk otomatis)" },
        { key: "pelanggan", label: "Nama Pelanggan" },
        { key: "product_id", label: "Produk Dipesan", type: "select", options: products.map((p) => ({ value: p.id, label: p.name })) },
        { key: "volume", label: "Volume Pesanan", type: "number", step: "0.1" },
        { key: "tanggal", label: "Tanggal Pesanan", type: "date" },
        { key: "deadline", label: "Deadline", type: "date" },
        { key: "status", label: "Status", type: "select", defaultValue: "draft", options: ["draft", "proses", "selesai", "dibatalkan"].map((v) => ({ value: v, label: v })) },
        { key: "catatan", label: "Catatan", type: "textarea", full: true },
      ]}
    />
  );
}
